import React from 'react';
import PropTypes from 'prop-types';
import '../css/Slideshow.css';
// import 'react-image-gallery/styles/css/image-gallery.css';
import ImageGallery from 'react-image-gallery';

const options = {
  showPlayButton: false,
  lazyLoad: true,
  showNav: true,
  showThumbnails: false,
  showFullscreenButton: false,
  showBullets: false,
  infinite: true,
};

/**
 * Slideshow component
 */
class Slideshow extends React.Component {
  static displayName = 'Slideshow';
  static propTypes = {
    className: PropTypes.string,
    images: PropTypes.array,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = 'Slideshow';
    this.state = {
      currentIndex: 0,
      items: this.getItems(),
    };
    this.handleSlide = this.handleSlide.bind(this);
    this.swipeSlide = this.swipeSlide.bind(this);
    this.imageUrl = this.imageUrl.bind(this);
  }

  handleSlide(currentIndex) {
    this.setState({currentIndex});
  }

  swipeSlide(side) {
    if (side === 'left') {
      const toIndex = this.imageGallery.getCurrentIndex() - 1;
      this.imageGallery.slideToIndex(toIndex);
    } else {
      const toIndex = this.imageGallery.getCurrentIndex() + 1;
      this.imageGallery.slideToIndex(toIndex);
    }
  }
  getItems() {
    let items = this.props.images.map(img => ({
      original: this.imageUrl(img),
    }));
    return items;
  }
  getCurrentTitle() {
    return this.state.items[this.state.currentIndex].title;
  }
  imageUrl(img) {
    const sizes = {
      mobile: 'url',
      desktop: 'urlx2',
      largedesktop: 'urlx3',
    };

    return img[sizes[this.props.screen]];
  }

  /**
   * @override
   */
  render() {
    return (
      <div className={`${this.className} ${this.props.className || ''}`}>
        <div className={`${this.className}__image`}>
          <ImageGallery
            {...options}
            ref={i => (this.imageGallery = i)}
            onSlide={this.handleSlide}
            items={this.state.items}
          />
          {/*
          <div className="zones">
            <div className="left" onClick={() => this.swipeSlide('left')} />
            <div className="right" onClick={() => this.swipeSlide('right')} />
          </div>
          */}
        </div>
        <div className={`${this.className}__infos`}>
          <div className={`${this.className}__title`}>
            {this.getCurrentTitle() || ''}
          </div>
          <div className={`${this.className}__count`}>
            {this.state.currentIndex + 1} / {this.state.items.length}
          </div>
        </div>
      </div>
    );
  }
}

export default Slideshow;
